module.exports = function (Vue, config) {
  Vue.mixin({
    created: function () {
      this.$config = config
    }
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-config/index.js
// module id = 235
// module chunks = 1